module.exports = __webpack_public_path__ + "img/6.f60fa936.jpg";